import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Loading } from '@components/common';

/**
 *
 * @param { initiators: Array, requesters: Array, selector: function } options
 * @param {*} childExtra
 * @description Only support no-arguments function
 */
const injectorServer = (options, childExtra) => (Wrapper) => {
  const {
    initiators: originalInitiators = [],
    requesters: originalRequesters = [],
    selector: originalSelector,
  } = options;

  class InjectorWrapper extends React.PureComponent {

    static defaultProps = {
      isFetching: false,
    };

    constructor(props) {
      super(props);
      const { initiators } = props;
      if (Array.isArray(initiators) && initiators.length > 0) {
        initiators.forEach(initiator => typeof initiator === 'function' && initiator());
      }
    }

    componentDidMount() {
      const { requesters } = this.props;
      if (Array.isArray(requesters) && requesters.length > 0) {
        requesters.forEach(requester => typeof requester === 'function' && requester());
      }
    }

    render() {
      const {
        isFetching,
        ...rest
      } = this.props;

      if (isFetching) {
        return (
          <Loading />
        );
      }

      return (
        <Wrapper {...rest} {...childExtra} />
      );
    }
  }

  return connect(originalSelector, dispatch => ({
    initiators: originalInitiators.map(initiator => bindActionCreators(initiator, dispatch)),
    requesters: originalRequesters.map(
      requester => bindActionCreators(requester, dispatch),
    ),
  }))(InjectorWrapper);
};

export default injectorServer;
